module.exports = __webpack_public_path__ + "static/media/gymky.4eb0793e.webp";